import { ChannelTypeEnum } from "../../types";
import EventBus from "../event-bus";
const wsErrorHook = new EventBus<{
  channelType?: ChannelTypeEnum;
  path: string;
  connectionDuration: number;
}>("wsErrorHook");

export default wsErrorHook;
